import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBRwQiTp5LyVZtgIZjKoAamYBdwqX9iYTA",
  authDomain: "hydro-calc2.firebaseapp.com",
  projectId: "hydro-calc2",
  storageBucket: "hydro-calc2.firebasestorage.app",
  messagingSenderId: "660229367689",
  appId: "1:660229367689:web:c89fe488ccec31d38f6358"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Firestore with persistent offline cache — works across multiple tabs
// and survives loss of cell signal on the fireground
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

export const storage = getStorage(app);
